import React from 'react';

function Why() {
  return (
    <section className="why" id="why">
      <div className="container why-content">
        <h2>Was passiert, wenn Facility Management wirkt - statt nur funktioniert?</h2>
        <p>
          Wenn Facility Management schlecht läuft, sehen viele nur das Symptom - unzuverlässige Dienstleister, steigende Kosten, Frust im Betrieb. Doch das eigentliche Problem sitzt tiefer: Die Branche ist in eine Struktur gezwängt, die Qualität verhindert.
        </p>
        <p>
          FH Consulting glaubt: Gebäudebetrieb muss nicht günstiger, sondern klüger werden. Wir schaffen die Rahmenbedingungen, in denen FM langfristig wirken kann - mit stabilen Prozessen, klaren Verantwortlichkeiten, digitaler Unterstützung und echter Partnerschaft auf Augenhöhe.
        </p>
        <p>
          So entsteht nachhaltige Qualität - nicht durch Kontrolle, sondern durch Vertrauen. Nicht durch neue Dienstleister, sondern durch neue Strukturen.
        </p>
      </div>
    </section>
  );
}

export default Why;
